<template>
    <div class="theme_component">
        <div  class="theme_list" v-for="theme in themes_data" :key="theme.id">
            <router-link :to="{name:'theme', params:{ id: theme.url}}">
                {{theme.title}}
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            themes_data:[
                {title:"火事の夢の意味は？【火事の状況・シーン別の夢占い】", url:"fire-dream-meaning", description:"火事に関する夢占い記事です"},
                {title:"猫の夢の意味は？【猫が登場する夢の状況・シーン別の夢占い】", url:"cat-dream-meaning", description:"猫に関する夢占い記事です"},
                {title:"好きな人の夢の意味は？【好きな人が登場する夢の状況・シーン別の夢占い】", url:"crush-love-dream-meaning", description:"好きな人に関する夢占い記事です"},
                {title:"赤ちゃんの夢の意味は？【赤ちゃんが登場する夢の状況・シーン別の夢占い】", url:"baby-dream-meaning", description:"赤ちゃんに関する夢占い記事です"},
                {title:"蛇の夢の意味は？【蛇が登場する夢の状況・シーン別の夢占い】", url:"snake-dream-meaning", description:"蛇に関する夢占い記事です"},
                // {title:"元彼の夢", url:"元彼", description:"元彼に関する夢占い記事です"},
                // {title:"犬の夢", url:"犬", description:"犬に関する夢占い記事です"},
            ]
        }
    }

}
</script>

<style scoped>
.theme_component{
    margin: 16px 0 16px 16px;
}
.theme_list{
    position: relative;
    font-size: 1.1em;
    margin: 8px 0 8px 0; 
}
.theme_list::after {
  display: block;
  content: '';
  position: absolute;
  top: .5em;
  left: -1em;
  width: 6px;
  height: 6px;
  border-right: 1px solid #666;
  border-bottom: 1px solid #666;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

</style>